export type url = string
export type milliseconds = number
export type percentage = number
export type language = 'en' | 'en-us' | 'es'
export type userAgent = string
export type IPAddress = string
export type id = string

export enum Queue {
    STREAM = 'stream',
    ANALYZE = 'video-analyze',
    LOGGING = 'logging',
    RENDER = 'render'
}

export enum ImpressionType {
    ANY = 'any',
    NATIVE = 'native',
    DISPLAY = 'display',
    VIDEO = 'video'
}

export enum MediaLocation {
    STORED = 'STORED',
    STREAM = 'STREAM',
    LIVE = 'LIVE'
}

export enum State {
    QUEUED = 'QUEUED',
    SUCCESS = 'SUCCESS',
    ANALYZING = 'ANALYZING',
    ANALYZED = 'ANALYZED',
    FAILED = 'FAILED'
}

export enum Area {
    ANNOTATE = 'ANNOTATE',
    PROBE = 'PROBE',
    INDEX = 'INDEX',
    OBJECTS = 'OBJECTS',
    TRANSCRIPT = 'TRANSCRIPT',
    LOGOS = 'LOGOS',
    SHOTS = 'SHOTS',
    TEXT = 'TEXT',
    EXPLICITS = 'EXPLICITS',
    SUMMARY = 'SUMMARY',
    LABELS = 'LABELS',
    FACES = 'FACES',
    CELEBRITIES = 'CELEBRITIES'
}

export enum GeoType {
    GPS_SERVICE = 1,
    IP_ADDRESS = 2,
    USER_PROVIDED = 3
}

export enum EventType {
    IMPRESSION = 1,
    VIEWABLE_MRC_50 = 2,
    VIEWABLE_MRC_100 = 3,
    VIEWABLE_VIDEO_50 = 4
}

export enum LogType {
    ALL = 'all',
    NONE = 'none',
    QA = 'qa',
    CXO = 'cxo',
    INSERT = 'insert',
    INFO = 'info',
    ERROR = 'error',
    HIGHLIGHT = 'highlight',
    IMPORTANT = 'important',
    TAM = 'tam',
    OVERLAYLOGS = 'overlaylogs'
}

export enum CueLogType {
    CUE_START = 1,
    CUE_END = 2
}

export enum EventTrackingMethod {
    IMG = 1,
    JS = 2
}

export enum Region {
    TL = 0,
    TR = 1,
    BL = 3,
    BR = 4,
    CENTER = 5,
    OUTSIDE = 6,
    COVER = 7
}

export enum DestinationSource {
    ENDPOINT = 0,
    FACEBOOK = 1,
    TWITTER = 2,
    YOUTUBE = 3
}

export enum BoolState {
    NEUTRAL = -1,
    FALSE = 0,
    TRUE = 1
}

export enum Protocol {
    TEXT = 0,
    JSON = 1,
    RTB2 = 2,
    RTB25 = 2.5,
    RTB30 = 3.0
}

export enum SiteMode {
    OFF = 0,
    ANALYZE = 1,
    SANDBOX = 2,
    PROSPECT = 3,
    LIVE = 4
}

export enum DemandSource {
    ALL = 'all',
    AMAZON = 'amazon',
    ADKERNEL = 'adkernel',
    CATAPULTX_PROSPECT = 'cxProspect',
    CATAPULTX_HISTORY = 'cxHistory',
    CATAPULTX = 'catapultx',
    OUTBRAIN = 'outbrain',
    OPENX = 'openx',
    VOLUUM = 'voluum',
    DDC = 'ddc',
    XENDIZ = 'xendiz',
    NONE = 'none'
}

export enum ZoneType{
    CTV = 'ctv-on-stream',
    WEB = 'web-on-stream'
}

export enum DebugURLParams{
    ALLOW_ADX = 'DEBUGallowADX',
    ALLOW_BLOCKED_DOMAINS = 'DEBUGallowBlockedDomains',
    ALLOW_REBIDS = 'DEBUGallowRebids',
    ALLOWED_INSERT_TYPES_ADD = 'DEBUGallowedInsertTypesAdd',
    ALLOWED_INSERT_TYPES_FORCE = 'DEBUGallowedInsertTypesForce',
    ALLOWED_INSERT_TYPES_ONSTREAM_FORCE = 'DEBUGallowedInsertTypesOnstreamForce',
    ALLOWED_INSERT_TYPES_FLOATING_FORCE = 'DEBUGallowedInsertTypesFloatingForce',
    ALLOWED_INSERT_TYPES_REMOVE = 'DEBUGallowedInsertTypesRemove',
    ALLOWED_EVENTS_PER_MINUTE = 'DEBUGallowedEventsPerMinute',
    ALLOWED_FAILED_BIDS = 'DEBUGallowedFailedBids',
    ANALYTICS_TIER = 'DEBUGanalyticsTier',
    BANNER_ALLOW_IFRAME_LOAD = 'DEBUGbannerAllowIframeLoad',
    BRAND_BUG = 'DEBUGbrandBug',
    CAROUSEL_MODE = 'DEBUGcarouselMode',
    CAROUSEL_SPEED = 'DEBUGcarouselSpeed',
    CX_LOG_MODE = 'cxLogMode',
    CX_LOG_TIMESTAMPS = 'cxLogTimestamps',
    CX_TIER = 'cxtier',
    DESTROY_INSERT_ON_CLOSE = 'DEBUGdestroyInsertOnClose',
    DISABLE_INSERT_OPEN_ANIMATION = 'DEBUGdisableInsertOpenAnimation',
    DISABLE_TAM = 'DEBUGdisableTAM',
    EXTERNAL_LOGGING = "DEBUGexternalLogging",
    FORCE_ADX = 'DEBUGforceADX',
    FORCE_BANNER_CUSTOM_SQUEEZE = 'DEBUGforceBannerCustomSqueeze',
    FORCE_CTV_MODE = 'DEBUGforceCTVMode',
    FORCE_HORIZONTAL_BANNER_SQUEEZEBACK = 'DEBUGforceHorizontalBannerSqueezeback',
    FAKE_NATIVE_BID = 'DEBUGfakeNativeBid',
    FORCE_BRAINLY = 'DEBUGforceBrainly',
    FORCE_OUTBRAIN = 'DEBUGforceOutbrain',
    FORCE_PREBID = 'DEBUGforcePrebid',
    FORCE_REV_CONTENT = 'DEBUGforceRevContent',
    FORCE_VERTICAL_BANNER_SQUEEZEBACK = 'DEBUGforceVerticalBannerSqueezeback',
    FORCE_MANUAL_BIDDING = 'DEBUGforceManualBidding',
    HIGHLIGHT_LOGS = 'DEBUGhighlightLogs',
    INSERT_ADJUST_POSITION = 'DEBUGinsertAdjustPosition',
    INSERT_DURATION = 'DEBUGinsertDuration',
    INSERT_FREQUENCY = 'DEBUGinsertFrequency',
    INSERT_OVERRIDE_POSITION = 'DEBUGinsertOverridePosition',
    INSERT_OVERRIDE_LOCATION = 'DEBUGinsertOverrideLocation',
    INSERT_OVERRIDE_Y_OFFSET = 'DEBUGinsertOverrideYOffset',
    INSERT_TYPE_OVERRIDE = 'DEBUGinsertTypeOverride',
    PRIVACY_URL = 'DEBUGprivacyURL',
    PREVENT_BANNER_ENLARGE = 'DEBUGpreventBannerEnlarge',
    ONBOARDING = 'DEBUGonboarding',
    OVERRIDE_CONFIGS_GROUP_ID = 'DEBUGoverrideConfigsGroupId',
    OVERRIDE_GEO_BLOCKING = 'DEBUGoverrideGeoBlocking',
    OVERRIDE_GROUP_ID = 'DEBUGoverrideGroupId',
    OVERRIDE_OSD_BID_ORDER = 'DEBUGoverrideOsdBidOrder',
    OVERRIDE_OVERLAY_POSITION = 'DEBUGoverrideOverlayPosition',
    OVERRIDE_TIMER_POSITION = 'DEBUGoverrideTimerPosition',
    PERSISTENT_INSERTS = 'DEBUGpersistentInserts',
    REMOVE_ASSET_DATA_OBJECT = 'DEBUGremoveAssetDataObject',
    REMOVE_LOGO = 'DEBUGremoveLogo',
    REMOVE_OSD = 'DEBUGremoveOSD',
    REMOVE_WATERFALL_BIDDING =  'DEBUGremoveWaterfall',
    REBID_ALLOWED_SIZE_DEVIATION = 'DEBUGrebidAllowedSizeDeviation',
    SHOW_CONSOLE_OVERLAY = 'DEBUGshowConsoleLogOverlay',
    TIMER_BASED_BIDDING = 'DEBUGtimerBasedBidding',
    ZONE_ACTIVE = 'DEBUGzoneActive',
    ZONE_MODIFICATIONS_ADD = 'DEBUGaddZoneModifications',
    ZONE_MODIFICATIONS_SET = 'DEBUGsetZoneModifications',
    Z_INDEX_OVERRIDE = 'DEBUGzIndexOverride',
}

export enum PlayerType{
    AIRTV = 'AIRTV',
    VIDEOINTELLIGENCE = 'VIDEOINTELLIGENCE',
    DAILYMOTION = 'DAILYMOTION',
    VDO = 'VDO',
    CONNATIX = 'CONNATIX',
    CLIX = 'CLIX',
    RUMBLE = 'RUMBLE',
    POWA_SHADOW = 'POWA_SHADOW',
    SYNCBAK = 'SYNCBAK',
    INSIGHT = 'INSIGHT',
    AKAMAI_AMP = 'AKAMAI_AMP',
    EXCO = 'EXCO',
    ANIPLAYER = 'ANIPLAYER', 
    AVANTIS = 'AVANTIS',
    FIRE_TV = 'FIRE_TV',
    FLOWPLAYER = 'FLOWPLAYER',
    IN_HOUSE = 'IN_HOUSE',
    MINUTE_MEDIA = 'MINUTE_MEDIA',
    PLAYKIT = 'PLAYKIT',
    ANYCLIP = 'ANYCLIP', 
    BRIDTV_PLAYER_2 = 'BRIDTV_PLAYER_2',
    BRIDTV = 'BRIDTV',
    FAVE = 'FAVE',
    PRIMIS = 'PRIMIS',
    MPLAYER = 'MPLAYER',
    MG2PLAYER = 'MG2PLAYER',
    STN_SHADOW = 'STN_SHADOW',
    STN = 'STN',
    TGH5 = 'TGH5',
    GOOGLE_AMP = 'GOOGLE_AMP',
    GSTREAM = 'GSTREAM',
    FUEL = "FUEL",
    FLUID = 'FLUID',
    GLOMEX = 'GLOMEX',
    ZYPE = 'ZYPE',
    VIDAZOO_SHADOW = 'VIDAZOO_SHADOW',
    VIDAZOO_VDZ = 'VIDAZOO_VDZ', 
    VIDAZOO = 'VIDAZOO', 
    BLUEBILLYWIG = 'BLUEBILLYWIG',
    BRIGHTCOVE = 'BRIGHTCOVE',
    BRIGHTCOVE_INLINE = 'BRIGHTCOVE_INLINE',
    FEED_CLIP = 'FEED_CLIP',
    JWPLAYER = 'JWPLAYER',
    VIDEOJS = 'VIDEOJS',
    UNKNOWN = 'UNKNOWN',
    ALL = 'ALL',
    SLIDESHOW = 'SLIDESHOW'
}

export enum PlayerMode{
    MOBILE_ONSTREAM = 'mobile-onstream',
    MOBILE_INARTICLE = 'mobile-inarticle',
    MOBILE_FLOATING = 'mobile-floating',
    DESKTOP_ONSTREAM = 'desktop-onstream',
    DESKTOP_INARTICLE = 'desktop-inarticle',
    DESKTOP_FLOATING = 'desktop-floating'
}

export enum InsertType {
    NONE = 'none',
    //DEFAULT NAMES - USED FOR MAPPING TO CURRENT INSERTS
    DEFAULT_OVERLAY_CORNER = 'default-overlay-corner',
    DEFAULT_OVERLAY_FULLWIDTH = 'default-overlay-fullwidth',
    DEFAULT_SQUEEZEBACK = 'default-squeezeback',
    DEFAULT_SQUEEZEBACK_CUSTOM = 'default-squeezeback-custom',
    DEFAULT_FLAP = 'default-bleedover-flap',
    DEFAULT_WING = 'default-bleedover-wing',
    DEFAULT_OVERLAY_CORNER_ICON = 'default-overlay-corner-icon',
    DEFAULT_OVERLAY_CORNER_NO_ICON = 'default-overlay-corner-no-icon',
    //DISPLAY (BANNER) INSERT FORMATS
    DISPLAY_FULLWIDTH_HORIZONTAL_OVERLAY = 'display-fullwidth-horizontal-overlay',
    DISPLAY_OVERLAY_CORNER_SLIDE = 'display-overlay-corner-slide',
    DISPLAY_BLEEDOVER_FLAP_FLOATING = 'display-bleedover-flap-floating',
    DISPLAY_BLEEDOVER_WING_MINI = 'display-bleedover-wing-mini',
    //SQUEEZEBACK FORMATS
    DISPLAY_SQUEEZE_BACK_BANNER = 'display-squeeze-back-banner',
    DISPLAY_CUSTOM_SQUEEZE_BACK = 'display-custom-squeeze-back',
    SQUEEZE_BACK_CUSTOM_FULL_BACKGROUND = 'squeeze-back-custom-full-background',
    SQUEEZE_BACK_CUSTOM_VIDEO_BACKGROUND = 'squeeze-back-custom-video-background',
    SQUEEZE_BACK_DYNAMIC_FULLWIDTH = 'squeeze-back-dynamic-fullwidth',
    //OVERLAY INSERT TYPES
    OVERLAY_HORIZONTAL_SLIDE_COLOR_DETECT = 'overlay-horizontal-slide-color-detect',
    OVERLAY_SLIDE_ICON_COLOR_DETECT = 'overlay-slide-icon-color-detect',
    OVERLAY_FULLWIDTH_ICON_COLOR_DETECT = 'overlay-fullwidth-icon-color-detect',
    //FLAP INSERT TYPES
    BLEEDOVER_FLAP_REVOLVING_HEADLINE = 'bleedover-flap-revolving-headline',
    //WING INSERT TYPES
    BLEEDOVER_WING_PRECISION_SIZE = 'bleedover-wing-precision-size',
    // CTV FORMATS
    CTV_OVERLAY_MAIN_IMAGE_ONLY = 'ctv-overlay-main-image-only',
    CTV_OVERLAY_CORNER_CLEAN_QR = 'ctv-overlay-corner-clean-qr',
    CTV_SQUEEZE_BACK_CUSTOM = 'ctv-squeeze-back-custom',
    CTV_SQUEEZE_BACK_CUSTOM_QR = 'ctv-squeeze-back-custom-qr'
}

export enum InsertTypePosition {
    NONE = 0,
    //1 -> Above the Fold
    OVERLAY_CORNER = 1,
    //3 -> Below the Fold
    OVERLAY_FULLWIDTH = 3,
    //4 -> Header
    BANNER_SQUEEZEBACK = 4,
    //5 -> Footer
    FLAP = 5,
    //6 -> Sidebar
    WING = 6,
    //7 -> Full-Screen
    CUSTOM_SQUEEZEBACK = 7,
}

export enum InsertOverrideType{
    POSITION = 'position',
    YOFFSET = 'yOffset'
}

export enum InsertEventType {
    EVENT_FROM_INSERT = 'event-from-insert',
    INSERT_INITIALIZED = 'insert-initialized',
    INSERT_CLOSED = 'insert-closed',
    INSERT_USER_CLOSED = 'insert-user-closed',
    INSERT_OPENED = 'insert-opened',
    INSERT_RENDERED = 'insert-rendered',
    INSERT_RERENDERED = 'insert-rerendered',
    INSERT_DESTROYED = 'insert-destroyed',
    INSERT_REQUEST_VIDEO = 'insert-request-video',
    INSERT_REQUEST_OSD_REFRESH = 'insert-request-osd-refresh',
    INSERT_SQUEEZE_START = 'insert-squeeze-start',
    INSERT_SQUEEZE_FINISH = 'insert-squeeze-finish',
    INSERT_TRACKING_EVENT = 'insert-tracking-event',
    INSERT_IMPRESSION = 'insert-impression',
    INSERT_DISPLAY_STARTED = 'insert-display-started',
    INSERT_BANNER_BLOCKED = 'insert-banner-blocked',
    INSERT_BANNER_FAILED = 'insert-banner-failed',
    INSERT_GPT_FAILED = 'insert-gpt-failed',
    INSERT_GPT_RENDER_FAILED = 'insert-gpt-render-failed',
    INSERT_VIEWED_EVENT= 'insert-viewed-event',
    INSERT_GPT_RESPONSE = 'insert-gpt-response',
    INSERT_GPT_REFRESH = 'insert-gpt-refresh',
    INSERT_GPT_RESET = 'insert-gpt-reset'
}

export enum OverlayEventType {
    EVENT_FROM_OVERLAY = 'event-from-overlay',
    OVERLAY_REQUEST_DESTROY = 'insert-to-destroy',
    OVERLAY_HANDOFF_VIDEO = 'overlay-handoff-video',
    OVERLAY_RESIZE = 'overlay-resize',
    OVERLAY_PAUSE_INSERTS = 'overlay-pause-inserts',
    OVERLAY_RESUME_INSERTS = 'overlay-resume-inserts',
    OVERLAY_REFRESH_ACTIVE_OSD = 'overlay-refresh-active-osd',
    OVERLAY_RESET_ACTIVE_OSD = 'overlay-reset-active-osd',
    OVERLAY_DESTROY_REMAINING_INSERTS = 'overlay-clear-all-inserts'
}

export enum ComponentSourceType {
    OVERLAY = 'OVERLAY',
    SLIDESHOW = 'SLIDESHOW',
    BID_ENRICHMENT = 'BID_ENRICHMENT',
    NONE = 'NONE'
}

export enum InsertPosition {
    TOP_LEFT = 'tl',
    TOP_RIGHT = 'tr',
    BOTTOM_LEFT = 'bl',
    BOTTOM_RIGHT = 'br',
    DEFAULT = 'def'
}

export enum CSSPosition {
    ABSOLUTE = 'absolute',
    UNSET = 'unset',
    RELATIVE = 'relative',
    FIXED = 'fixed',
    STATIC = 'static'
}

export enum FloatingPlayerPosition {
    TOP_LEFT = 'tl',
    TOP_RIGHT = 'tr',
    BOTTOM_LEFT = 'bl',
    BOTTOM_RIGHT = 'br',
    CENTER = 'center',
    TOP_CENTER = 'top-center'
}

export enum OverlayExternalEventType {
    IMPRESSION = 'cx-impression',
    INSERT_MOMENT_BEGIN = 'cx-insert-moment-begin',
    INSERT_MOMENT_END = 'cx-insert-moment-end'
}

export enum LoggerEventType {
    DISPATCH_LOG = 'dispatch-log'
}

export enum AnalyticsEventBaseType{
    //Base player event types
    BID = "BID",
    INSERT = "INSERT",
    VIDEO = "VIDEO",
    OVERLAY = "OVERLAY",
    GAM = "GAM",
    PREBID = "PREBID",
    TAM = "TAM",
    BID_ENRICHMENT = "BID_ENRICHMENT"
}

export enum AnalyticsEventType{
    BID_REQUEST = "REQUEST",
    BID_NO_REQUEST = "NO_REQUEST",
    BID_RESPONSE = "RESPONSE",
    BID_RESPONSE_EMPTY = "RESPONSE_EMPTY",

    GAM_REQUEST = "REQUEST",
    GAM_RESPONSE = "RESPONSE",
    GAM_RESPONSE_EMPTY = "RESPONSE_EMPTY",
    GAM_RENDER_FAIL = "RENDER_FAIL",
    GAM_RENDER_SUCCESS = "RENDER_SUCCESS",
    GAM_SLOT_LOAD_SUCCESS = "SLOT_LOAD_SUCCESS",

    PREBID_REQUEST = "REQUEST",
    PREBID_RESPONSE = "RESPONSE",
    PREBID_WON = "WON",
    
    TAM_REQUEST = "REQUEST",
    TAM_RESPONSE = "RESPONSE",
    
    OVERLAY_INIT = "INIT",
    OVERLAY_PAGE_INDEX = "OVERLAY_INDEX",
    OVERLAY_TIME_REACHED = "TIME_REACHED",
    OVERLAY_CAPTURE_VIDEO_POSITION = "CAPTURE_VIDEO_POSITION",
    OVERLAY_CAPTURE_AD_CONCENTRATION = "CAPTURE_AD_CONCENTRATION",
    OVERLAY_ANDROID_WEB_VIEW = "ANDROID_WEB_VIEW",
    OVERLAY_IN_APP_BROWSER_SHUTDOWN = "IN_APP_BROWSER_SHUTDOWN",
    OVERLAY_HOST_FOUND = "HOST_FOUND",
    OVERLAY_GROUPID_ZONE_MISMATCH = "GROUPID_ZONE_MISMATCH",
    OVERLAY_GROUPID_NOT_FOUND = "GROUPID_NOT_FOUND",
    OVERLAY_GEO_BLOCKED_REGION = "GEO_BLOCKED_REGION",
    OVERLAY_GROUP_CONFIGS = "OVERLAY_GROUP_CONFIGS",
    OVERLAY_FORCED_SHUTDOWN = "FORCED_SHUTDOWN",
    OVERLAY_FETCH_MOMENTS = "FETCH_MOMENTS",
    CLS_INIT = "CLS_INIT",
    CLS_SHIFT_OBSERVED = "CLS_SHIFT_OBSERVED",

    BID_ENRICH_INIT = "INIT",
    BID_ENRICH_INDEX = "INDEX",
    BID_ENRICH_AUCTION_END = "AUCTION_END",
    BID_ENRICH_GOOGLETAG_IMPRESSION = "GOOGLETAG_IMPRESSION",

    VIDEO_SRC_CHANGED = "SRC_CHANGED",
    VIDEO_STARTED = "STARTED",
    VIDEO_ENDED = "ENDED",
    VIDEO_RESTARTED = "RESTARTED",
    VIDEO_TIME_REACHED = "TIME_REACHED",
    VIDEO_QUARTILE_COMPLETE = "QUARTILE_COMPLETE",
    VIDEO_PLAY = "PLAY",
    VIDEO_PAUSE = "PAUSE",

    INSERT_CREATED = "CREATED",
    INSERT_NOT_CREATED = "NOT_CREATED",
    INSERT_CREATION_DELAYED = "CREATION_DELAYED",
    INSERT_REBUILD = "REBUILD", 
    INSERT_INITIALIZED = "INITIALIZED",
    INSERT_RENDERED = "RENDERED",
    INSERT_RERENDERED = "RERENDERED",
    INSERT_DESTROYED = "DESTROYED",
    INSERT_DISPLAYED = "DISPLAYED",
    INSERT_IMPRESSION = "IMPRESSION",
    INSERT_NO_IMPRESSION = "NO_IMPRESSION",
    INSERT_CLOSED = "CLOSED",
    INSERT_USER_CLOSED = "USER_CLOSED",
    INSERT_REOPENED = "REOPENED",
    INSERT_CLICKTHROUGH = "CLICKTHROUGH",
    INSERT_PRIVACY_CLICKTHROUGH = "PRIVACY_CLICKTHROUGH",
    INSERT_LOGO_CLICKTHROUGH = "LOGO_CLICKTHROUGH",
    INSERT_OUTBRAIN_CLICKTHROUGH = "OUTBRAIN_CLICKTHROUGH",
    INSERT_VIEWED = "VIEWED",
    INSERT_ADBLOCKED = "ADBLOCKED",
    INSERT_BANNER_BLOCKED = "BANNER_BLOCKED",
    INSERT_BANNER_LOAD_FAILED = "LOAD_FAILED",
    INSERT_LOAD_FAILED = "LOAD_FAILED"
}

export enum VideoEventQuartileNaming{
    ZERO = "START",
    FIRST = "FIRST_QUARTILE",
    SECOND = "MIDPOINT",
    THIRD = "THIRD_QUARTILE",
    FOURTH = "COMPLETE"
}

export enum PlayerEventLogFrequency{
    ALL = 'ALL',
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
    NONE = 'NONE'
}

export enum ZoneModifications{
    ALWAYS_ON = 'always-on',
    BRAINLY = 'brainly',
    DISABLE_OPEN_ANIMATION = 'disable-insert-animation',
    DISABLE_TAM = 'disable-tam',
    HIDE_UI = 'hide-ui',
    PREVENT_BANNER_UPSCALE = 'prevent-banner-upscale',
    REMOVE_INSERT_CLOSE_BUTTON = 'remove-insert-close-button',
    REMOVE_LOGO = 'remove-logo',
    MANUAL_BIDDING= 'manual-bidding',
    ROUNDED_INSERT_EDGES = 'rounded-insert-edges'
}

export enum BidOriginSourceType{
    CX_EXCHANGE = 'CXE',
    ADK = 'ADK',
    ADX = 'ADX',
    REV_CONTENT = 'REV_CONTENT',
    OSD = 'OSD',
    PLATFORM = 'PLATFORM',
    OUTBRAIN = 'OUTBRAIN'
}

export enum OsdBidOrderOption {
    ALL = "ALL",
    QORTEX_EXCLUDED = "QORTEX_EXCLUDED",
    QORTEX_ONLY = "QORTEX_ONLY"
}

export enum QortexSendMessageType {
    CX_BID_ENRICH_INITIALIZED = "CX-BID-ENRICH-INITIALIZED",
    DISPATCH_CONTEXT = 'DISPATCH-CONTEXT'
}

export enum QortexReceiveMessageType {
    AUCTION_END = 'AUCTION-END',
    NO_CONTEXT = 'NO-CONTEXT',
    RTD_INITIALIZED = 'RTD-INITIALIZED',
    REQUEST_CONTEXT = 'REQUEST-CONTEXT'
  }

export enum InsertAnalyticsEventType {
    DISPLAYED = 'displayed',
    REDISPLAYED = 're-displayed',
    ADX_DISPLAYED = 'adx-displayed',
    CLICKTHROUGH = 'clickthrough',
    BANNER_CLICKTHROUGH = 'banner_clickthrough',
    PRIVACY_CLICKTHROUGH = 'privacy_clickthrough',
    LOGO_CLICKTHROUGH = 'logo-clickthrough',
    OUTBRAIN_CLICKTHROUGH = 'outbrain-clickthrough',
    USER_CLOSED = 'user-closed',
    USER_EXPANDED = 'user-expanded', 
    BID_REQUEST = 'bid-request',
    VIDEO_START = 'video-start',
    VIDEO_15_SECONDS = 'video-15-seconds',
    ERROR_ASSIGNDATA = 'error-insert-assign-data'
}

export enum BannerMessageType {
    GPT_LOAD_FAILED = 'GPT load failed',
    GPT_RENDER_FAILED = 'GPT render failed',
    GPT_LOAD_SUCCESSFUL = 'GPT load complete',
    GPT_RESPONSE_RECEIVED = 'GPT response received',
    LOAD_FAILED = 'Banner load failed',
    LOAD_COMPLETE = 'Banner load complete',
    DIRECT_DISPLAY_LOAD = 'Direct display loaded'
}

export enum ImageAssetType {
    ICON = 1,
    LOGO = 2,
    MAIN = 3
}

export enum BidType {
    CPM = 'CPM',
    CPX = 'CPX'
}

export enum DataAssetType {
    SPONSORED = 1,
    DESC = 2,
    RATING = 3,
    LIKES = 4,
    DOWNLOADS = 5,
    PRICE = 6,
    SALEPRICE = 7,
    PHONE = 8,
    ADDRESS = 9,
    DESC2 = 10,
    DISPLAYURL = 11,
    CTATEXT = 12
}
